import React from 'react';
import FeedPage from 'src/components/FeedPage/FeedPage';
import { searchProducts, setCurrentQuery, setIsLoadingProducts } from 'src/lib/redux/modules/search';
import { wrapper } from 'src/lib/redux/store';
import { connect } from 'react-redux';
import { END } from '@redux-saga/core';
import {
	setCurrentDevice,
	setCurrentPage,
	setCurrentTheme,
	setLocale,
	setResolvedUrl,
	setSSRData,
	setWhoAmI,
} from 'src/lib/redux/modules/settings';
import { FRESH_THEME, REQUEST_ID_PREFIX, RUSTY_THEME, SESSION_ID_KEY } from 'src/lib/constants/general';
import { resolveHost } from 'src/lib/whoami';
import { uuid } from 'src/lib/utils';
import { getCookie } from 'src/lib/managers/StorageManager';
import QueryManager from 'src/lib/managers/QueryManager';
import { getDefaultCid } from 'src/lib/helpers';

function getClientIp(req) {
	let ip = req.headers['cf-connecting-ip'] || req.headers['x-forwarded-for'] || req.socket.remoteAddress || '';
	if (typeof ip !== 'string') {
		ip = '';
	}
	return ip.split(',')[0].trim();
}

export const getServerSideProps = wrapper.getServerSideProps(store => async context => {
	global.XMLHttpRequest = require('xmlhttprequest').XMLHttpRequest;
	const isMobile = require('is-mobile');
	const { req, query, resolvedUrl, locale } = context;
	const { headers } = req;
	const { host, cookie } = headers;
	const { slug, cid } = query;

	const clientIp = getClientIp(req);
	const sessionIdCookie = getCookie(SESSION_ID_KEY, cookie) || uuid(); // perssist sessionId from client, // !will not work on localhost, will work with real domains (next developer: change host file)
	const whoami = resolveHost(host);
	const referrer = `https://${host}`;
	const { FULL_DOMAIN } = whoami;
	const keyword = QueryManager.unslugify(slug);
	const currentPage = resolvedUrl.split('?')[0];
	const userAgent = headers['user-agent'];
	const isInMobile = isMobile({ ua: userAgent, tablet: false });
	const requestId = uuid(REQUEST_ID_PREFIX);

	store.dispatch(setLocale({ locale }));
	store.dispatch(setWhoAmI({ whoami }));
	store.dispatch(setCurrentTheme(isInMobile ? FRESH_THEME : RUSTY_THEME));
	store.dispatch(setCurrentDevice({ mobile: isInMobile, desktop: !isInMobile }));
	store.dispatch(setCurrentQuery(keyword || ''));
	store.dispatch(setCurrentPage(currentPage));
	store.dispatch(setResolvedUrl(resolvedUrl));
	store.dispatch(setIsLoadingProducts(false)); // Its Deliberately on false - fix SearchBar bug loading diff between client and server class

	const defaultCid = getDefaultCid(); // must be here
	const currentCid = cid || defaultCid;
	const fetchParams = {
		...query,
		q: keyword || '',
		sessionStart: true,
		rlToken: 'GamarOtanuShayTheSecond',
		cid: currentCid,
		sessionId: sessionIdCookie,
	};

	const urlParams = { cid: currentCid, q: keyword || '', ...query };

	const ssrData = {
		urlParams,
		userAgent,
		referrer,
		host,
		appName: FULL_DOMAIN.toLowerCase(),
		cid: currentCid,
		currentPage,
		sessionId: sessionIdCookie,
		geo: locale,
		resolvedUrl,
		clientIp,
		requestId,
	};

	store.dispatch(setSSRData(ssrData));
	if (!store.getState().search.isLoadedProducts) {
		store.dispatch(searchProducts(fetchParams, ssrData));
		store.dispatch(END);
	}

	await store.sagaTask.toPromise();
	return {
		props: {
			host,
			sessionId: ssrData.sessionId,
			requestId,
			ssrData,
		},
	};
});

const Keyword = props => {
	const { host } = props;
	return <FeedPage host={host} />;
};

export default connect(state => state)(Keyword);
